/**
 * Environment type definitions for Sandbox/Production mode management.
 */

/**
 * Environment type - either sandbox or production
 */
export type Environment = 'sandbox' | 'production';

/**
 * Environment context type for React context
 */
export interface EnvironmentContextType {
  /** Current environment */
  environment: Environment;

  /** Set environment and persist to storage */
  setEnvironment: (env: Environment) => void;

  /** Toggle between sandbox and production */
  toggleEnvironment: () => void;

  /** Whether production warning should be shown */
  showProductionWarning: boolean;

  /** Callback to confirm production switch */
  confirmProductionSwitch: () => void;

  /** Callback to cancel production switch */
  cancelProductionSwitch: () => void;
}

/**
 * Environment display configuration
 */
export interface EnvironmentConfig {
  /** Display label for the environment */
  label: string;

  /** CSS class for styling */
  className: string;

  /** Background color */
  backgroundColor: string;

  /** Text color */
  textColor: string;

  /** Icon or emoji for the environment */
  icon?: string;
}

/**
 * Environment configuration map
 */
export const ENVIRONMENT_CONFIG: Record<Environment, EnvironmentConfig> = {
  sandbox: {
    label: 'SANDBOX MODE',
    className: 'environment-sandbox',
    backgroundColor: '#10b981', // green
    textColor: '#ffffff',
    icon: '🧪'
  },
  production: {
    label: 'PRODUCTION MODE',
    className: 'environment-production',
    backgroundColor: '#ef4444', // red
    textColor: '#ffffff',
    icon: '⚠️'
  }
};

/**
 * Storage key for environment persistence
 */
export const ENVIRONMENT_STORAGE_KEY = 'db-editor-environment';
